import { createIntl, type IntlCache, type IntlConfig, type IntlShape } from 'react-intl';
import { getFormattingLocale } from '@/utils/detectLocale';
import type { SupportedLocale } from '@/utils/localeStorage';

/**
 * The app's IntlShape (868mqhj74).
 *
 * `intl.locale` stays the language ('en' | 'es'): many call sites compare it to
 * pick copy or send it to the API. Numbers, percentages and money format with
 * the formatting locale instead, so Spanish reads "$63,247.48" and "42.9%"
 * (es-US, Florida) rather than "63.247,48 US$". Dates keep the language locale.
 */
export function createAppIntl(
  config: Omit<IntlConfig, 'locale'> & { locale: SupportedLocale },
  cache?: IntlCache,
): IntlShape {
  const intl = createIntl(config, cache);
  const formattingLocale = getFormattingLocale(config.locale);
  if (formattingLocale === config.locale) {
    return intl;
  }
  const numbers = createIntl({ ...config, locale: formattingLocale }, cache);
  return {
    ...intl,
    formatNumber: numbers.formatNumber,
    formatNumberToParts: numbers.formatNumberToParts,
  };
}
